export const authConfig = {
  loginUrl: "/login",
  loginUrlForRedirect: (redirectUrl: string) =>
    `/login?redirect=${encodeURIComponent(redirectUrl)}`,
  normalUserCallbackUrl: "/painel",
  adminUserCallbackUrl: "/admin/dashboard",
};
